module.exports = __webpack_public_path__ + "static/media/captain_jack_sparrow.cffcd24e.jpg";